import React, { type ReactNode } from 'react';

import { Anchor, xcss } from '@atlaskit/primitives';

const cardStyles = xcss({
	display: 'block',
	textDecoration: 'none',
	height: '100%',
	borderRadius: 'border.radius',
	transition: 'box-shadow 200ms',
	color: 'color.text.subtlest',

	':hover': {
		color: 'color.text.subtlest',
		textDecoration: 'none',
	},
});

const normalCardStyles = xcss({
	backgroundColor: 'elevation.surface.raised',
	boxShadow: 'elevation.shadow.raised',

	':hover': {
		boxShadow: 'elevation.shadow.overlay',
	},
});

const invertedCardStyles = xcss({
	backgroundColor: 'elevation.surface.sunken',
});

interface CardLinkProps {
	to: string;
	children: ReactNode;
	variant?: 'normal' | 'inverted';
}

const CardLink = ({ to, children, variant = 'normal' }: CardLinkProps) => {
	return (
		<Anchor
			xcss={[
				cardStyles,
				variant === 'normal' && normalCardStyles,
				variant === 'inverted' && invertedCardStyles,
			]}
			href={to}
		>
			{children}
		</Anchor>
	);
};

export default CardLink;
